/** @jsxImportSource theme-ui @jsxRuntime classic */
import { H } from '@hzdg/sectioning';
import {
  AnchorSection,
  Box,
  Container,
  Flex,
  Grid,
  IntrinsicImage,
  Link,
} from '@tishman/components';
import React from 'react';

import type { IGatsbyImageData } from 'gatsby-plugin-image';

export type GridDataItem = {
  title?: string;
  description?: string;
  imageOrVideo?: {
    image?: {
      asset?: {
        gatsbyImageData?: IGatsbyImageData;
        altText?: string;
      };
    };
  };
  buttonText: string;
  buttonLink: string;
};

type HolidaysFeaturedShopProps = {
  sectionTitle?: string;
  sectionLink?: string;
  gridData: readonly GridDataItem[];
  id: string;
};

export function HolidaysFeaturedShops({
  sectionTitle,
  sectionLink,
  id,
  gridData,
}: HolidaysFeaturedShopProps): React.JSX.Element {
  return (
    <AnchorSection id={id} theme="Rock Center White">
      <Container py={[5, '80px']}>
        {/* SECTION TITLE & LINK */}
        <Flex
          sx={{
            flexDirection: ['column', null, 'row'],
            justifyContent: 'space-between',
            mb: 5,
          }}
        >
          {sectionTitle && (
            <H
              sx={{
                variant: 'styles.h1',
                fontSize: 6,
              }}
            >
              {sectionTitle}
            </H>
          )}
          {sectionLink && (
            <Flex
              sx={{
                alignItems: 'center',
                width: 'fit-content',
                zIndex: 0,
              }}
            >
              <Link
                href={sectionLink}
                sx={{ display: 'flex', columnGap: 2 }}
                variant="underline"
              >
                View All
              </Link>
            </Flex>
          )}
        </Flex>
        {/* THREE COLUMN GRID */}
        <Grid
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
            gridGap: 4,
          }}
        >
          {gridData &&
            gridData.map((item: GridDataItem, i) => {
              return (
                <Flex
                  key={`${item?.title}-${i}`}
                  sx={{ flexDirection: 'column' }}
                >
                  <Box>
                    {item?.imageOrVideo?.image?.asset?.gatsbyImageData && (
                      <IntrinsicImage
                        alt={item?.imageOrVideo?.image?.asset?.altText}
                        image={
                          item?.imageOrVideo?.image?.asset?.gatsbyImageData
                        }
                        ratio={[327 / 217, null, 348 / 217]}
                      />
                    )}
                  </Box>
                  <Box sx={{ fontSize: 4, fontWeight: 500, my: 3 }}>
                    {item?.title}
                  </Box>
                  <Box sx={{ fontSize: 3 }}>{item?.description}</Box>
                  <Box sx={{ mt: 'auto', pt: 4 }}>
                    <Link to={item?.buttonLink} variant="underline">
                      {item.buttonText}
                    </Link>
                  </Box>
                </Flex>
              );
            })}
        </Grid>
      </Container>
    </AnchorSection>
  );
}
